import clsx from 'clsx';

export const sliderClasses = clsx`
  h-4
  w-full
  appearance-none
  rounded-2
  outline-none
  disabled:opacity-40
`;

export const browserClasses = clsx`
  [&::-moz-range-thumb]:h-24
  [&::-moz-range-thumb]:w-24
  [&::-moz-range-thumb]:rounded-full
  [&::-moz-range-thumb]:border-[3px]
  [&::-moz-range-thumb]:border-solid
  [&::-moz-range-thumb]:border-red-100
  [&::-moz-range-thumb]:bg-white-100
  [&::-moz-range-thumb]:transition-all
  [&::-webkit-slider-thumb]:h-24
  [&::-webkit-slider-thumb]:w-24
  [&::-webkit-slider-thumb]:appearance-none
  [&::-webkit-slider-thumb]:rounded-full
  [&::-webkit-slider-thumb]:border-[3px]
  [&::-webkit-slider-thumb]:border-solid
  [&::-webkit-slider-thumb]:border-red-100
  [&::-webkit-slider-thumb]:bg-white-100
  [&::-webkit-slider-thumb]:transition-all
  [&::-moz-range-thumb]:hover:[&:not(:disabled)]:shadow-lg
  [&::-moz-range-thumb]:active:[&:not(:disabled)]:h-32
  [&::-moz-range-thumb]:active:[&:not(:disabled)]:w-32
  [&::-webkit-slider-thumb]:hover:[&:not(:disabled)]:shadow-md
  [&::-webkit-slider-thumb]:active:[&:not(:disabled)]:h-32
  [&::-webkit-slider-thumb]:active:[&:not(:disabled)]:w-32
`;
